import type { PropsWithChildren } from 'react';
import { useContext } from 'react';
import { Helmet } from 'react-helmet-async';

import { Toaster } from '~/components/Toast';
import { cn } from '~/lib/cn';
import { BrandContext } from '~/modules/branding';

export function RootLayout({ children }: PropsWithChildren) {
  const brand = useContext(BrandContext);

  return (
    <>
      <Helmet titleTemplate={brand.titleTemplate} defaultTitle={brand.title}>
        <link
          rel="icon"
          type="image/png"
          href={`/images/${brand.name?.toLowerCase()}-logo.webp`}
        />
      </Helmet>
      <section
        className={cn(
          '@container/top',
          'dark flex min-h-dvh min-w-full overscroll-contain bg-default text-default',
        )}
      >
        {children}
      </section>
      <Toaster offset="1rem" />
    </>
  );
}

RootLayout.displayName = 'RootLayout';
